export function parse(name) {
    name = name.split(':');

    let value = name.length === 1 ? null : name.pop();

    return {
        name: name.join(':'),
        value
    };
}
